<div  class="sportsContainer" *ngFor="let sport of SportsAvailable">
    <sport-item [sports]="sport"></sport-item>
</div>
